/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ChangelogRouteImport } from './routes/changelog'
import { Route as LoginRouteImport } from './routes/login'
import { Route as LogoutRouteImport } from './routes/logout'
import { Route as ProfileRouteImport } from './routes/profile'
import { Route as StatsRouteImport } from './routes/stats'
import { Route as WrapRouteImport } from './routes/wrap'
import { Route as AdminEventsRouteImport } from './routes/admin/events'
import { Route as AdminSuggestionsRouteImport } from './routes/admin/suggestions'
import { Route as BookingIndexRouteImport } from './routes/booking/index'
import { Route as AdminOfficesIndexRouteImport } from './routes/admin/offices/index'
import { Route as AdminOfficesOfficeIdRouteImport } from './routes/admin/offices/$officeId'
import { Route as AdminUsersIndexRouteImport } from './routes/admin/users/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ChangelogRoute = ChangelogRouteImport.update({
  id: '/changelog',
  path: '/changelog',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const LogoutRoute = LogoutRouteImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRouteImport,
} as any)
const ProfileRoute = ProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => rootRouteImport,
} as any)
const StatsRoute = StatsRouteImport.update({
  id: '/stats',
  path: '/stats',
  getParentRoute: () => rootRouteImport,
} as any)
const WrapRoute = WrapRouteImport.update({
  id: '/wrap',
  path: '/wrap',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminEventsRoute = AdminEventsRouteImport.update({
  id: '/admin/events',
  path: '/admin/events',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSuggestionsRoute = AdminSuggestionsRouteImport.update({
  id: '/admin/suggestions',
  path: '/admin/suggestions',
  getParentRoute: () => rootRouteImport,
} as any)
const BookingIndexRoute = BookingIndexRouteImport.update({
  id: '/booking/',
  path: '/booking/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminOfficesIndexRoute = AdminOfficesIndexRouteImport.update({
  id: '/admin/offices/',
  path: '/admin/offices/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminOfficesOfficeIdRoute = AdminOfficesOfficeIdRouteImport.update({
  id: '/admin/offices/$officeId',
  path: '/admin/offices/$officeId',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersIndexRoute = AdminUsersIndexRouteImport.update({
  id: '/admin/users/',
  path: '/admin/users/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/changelog': typeof ChangelogRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/profile': typeof ProfileRoute
  '/stats': typeof StatsRoute
  '/wrap': typeof WrapRoute
  '/admin/events': typeof AdminEventsRoute
  '/admin/suggestions': typeof AdminSuggestionsRoute
  '/booking/': typeof BookingIndexRoute
  '/admin/offices/$officeId': typeof AdminOfficesOfficeIdRoute
  '/admin/offices/': typeof AdminOfficesIndexRoute
  '/admin/users/': typeof AdminUsersIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/changelog': typeof ChangelogRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/profile': typeof ProfileRoute
  '/stats': typeof StatsRoute
  '/wrap': typeof WrapRoute
  '/admin/events': typeof AdminEventsRoute
  '/admin/suggestions': typeof AdminSuggestionsRoute
  '/booking': typeof BookingIndexRoute
  '/admin/offices/$officeId': typeof AdminOfficesOfficeIdRoute
  '/admin/offices': typeof AdminOfficesIndexRoute
  '/admin/users': typeof AdminUsersIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/changelog': typeof ChangelogRoute
  '/login': typeof LoginRoute
  '/logout': typeof LogoutRoute
  '/profile': typeof ProfileRoute
  '/stats': typeof StatsRoute
  '/wrap': typeof WrapRoute
  '/admin/events': typeof AdminEventsRoute
  '/admin/suggestions': typeof AdminSuggestionsRoute
  '/booking/': typeof BookingIndexRoute
  '/admin/offices/$officeId': typeof AdminOfficesOfficeIdRoute
  '/admin/offices/': typeof AdminOfficesIndexRoute
  '/admin/users/': typeof AdminUsersIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/changelog'
    | '/login'
    | '/logout'
    | '/profile'
    | '/stats'
    | '/wrap'
    | '/admin/events'
    | '/admin/suggestions'
    | '/booking/'
    | '/admin/offices/$officeId'
    | '/admin/offices/'
    | '/admin/users/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/changelog'
    | '/login'
    | '/logout'
    | '/profile'
    | '/stats'
    | '/wrap'
    | '/admin/events'
    | '/admin/suggestions'
    | '/booking'
    | '/admin/offices/$officeId'
    | '/admin/offices'
    | '/admin/users'
  id:
    | '__root__'
    | '/'
    | '/changelog'
    | '/login'
    | '/logout'
    | '/profile'
    | '/stats'
    | '/wrap'
    | '/admin/events'
    | '/admin/suggestions'
    | '/booking/'
    | '/admin/offices/$officeId'
    | '/admin/offices/'
    | '/admin/users/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ChangelogRoute: typeof ChangelogRoute
  LoginRoute: typeof LoginRoute
  LogoutRoute: typeof LogoutRoute
  ProfileRoute: typeof ProfileRoute
  StatsRoute: typeof StatsRoute
  WrapRoute: typeof WrapRoute
  AdminEventsRoute: typeof AdminEventsRoute
  AdminSuggestionsRoute: typeof AdminSuggestionsRoute
  BookingIndexRoute: typeof BookingIndexRoute
  AdminOfficesOfficeIdRoute: typeof AdminOfficesOfficeIdRoute
  AdminOfficesIndexRoute: typeof AdminOfficesIndexRoute
  AdminUsersIndexRoute: typeof AdminUsersIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/changelog': {
      id: '/changelog'
      path: '/changelog'
      fullPath: '/changelog'
      preLoaderRoute: typeof ChangelogRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/logout': {
      id: '/logout'
      path: '/logout'
      fullPath: '/logout'
      preLoaderRoute: typeof LogoutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/profile': {
      id: '/profile'
      path: '/profile'
      fullPath: '/profile'
      preLoaderRoute: typeof ProfileRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stats': {
      id: '/stats'
      path: '/stats'
      fullPath: '/stats'
      preLoaderRoute: typeof StatsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/wrap': {
      id: '/wrap'
      path: '/wrap'
      fullPath: '/wrap'
      preLoaderRoute: typeof WrapRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/events': {
      id: '/admin/events'
      path: '/admin/events'
      fullPath: '/admin/events'
      preLoaderRoute: typeof AdminEventsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/suggestions': {
      id: '/admin/suggestions'
      path: '/admin/suggestions'
      fullPath: '/admin/suggestions'
      preLoaderRoute: typeof AdminSuggestionsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/booking/': {
      id: '/booking/'
      path: '/booking'
      fullPath: '/booking/'
      preLoaderRoute: typeof BookingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/offices/': {
      id: '/admin/offices/'
      path: '/admin/offices'
      fullPath: '/admin/offices/'
      preLoaderRoute: typeof AdminOfficesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/offices/$officeId': {
      id: '/admin/offices/$officeId'
      path: '/admin/offices/$officeId'
      fullPath: '/admin/offices/$officeId'
      preLoaderRoute: typeof AdminOfficesOfficeIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users/': {
      id: '/admin/users/'
      path: '/admin/users'
      fullPath: '/admin/users/'
      preLoaderRoute: typeof AdminUsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ChangelogRoute: ChangelogRoute,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
  ProfileRoute: ProfileRoute,
  StatsRoute: StatsRoute,
  WrapRoute: WrapRoute,
  AdminEventsRoute: AdminEventsRoute,
  AdminSuggestionsRoute: AdminSuggestionsRoute,
  BookingIndexRoute: BookingIndexRoute,
  AdminOfficesOfficeIdRoute: AdminOfficesOfficeIdRoute,
  AdminOfficesIndexRoute: AdminOfficesIndexRoute,
  AdminUsersIndexRoute: AdminUsersIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
